var BASWebServices;
(function (BASWebServices) {
    var UploadElementController = (function () {
        function UploadElementController($scope, $rootScope, $upload, $timeout, ngDialog, $http, $sce, wsData, configService) {
            this.$scope = $scope;
            this.$rootScope = $rootScope;
            this.$upload = $upload;
            this.$timeout = $timeout;
            this.ngDialog = ngDialog;
            this.$http = $http;
            this.$sce = $sce;
            this.wsData = wsData;
            this.configService = configService;
            this.$scope.uec = this;
        }
        UploadElementController.prototype.onFileSelect = function ($files, fileParameterName, supportedFileExtensions, isFilePartOfServiceOption) {
            console.log("Uploading files to parameter name: " + fileParameterName);
            this.$rootScope.dimmingPage = true;
            var supportedFileExtensionsSplit = supportedFileExtensions.split(" ");
            for (var i = 0; i < $files.length; i++) {
                var $file = $files[i];
                var supportedFileType = false;
                for (var j = 0; j < supportedFileExtensionsSplit.length; j++) {
                    if ($file.name.toLowerCase().lastIndexOf(supportedFileExtensionsSplit[j].toLowerCase()) != -1) {
                        supportedFileType = true;
                        break;
                    }
                }
                var containsBadChar = BASWebServices.ConfigService.CONTAINS_BAD_CHARACTER($file.name);
                if (!supportedFileType) {
                    var message = "Unsupported file type on file: " + $file.name + ".";
                    var suportedFileTypes = "Supported types are '" + supportedFileExtensions + "'.";
                    this.$rootScope.$broadcast('messageForBox', 'ERROR', 'Invalid file extensions (supported ones are ' + supportedFileExtensions + ')', message);
                    console.info("UploadElementController: " + message + " " + suportedFileTypes);
                    this.$rootScope.dimmingPage = false;
                    this.$rootScope.$broadcast("dimming_screen_off");
                    return;
                }
                else if (containsBadChar) {
                    this.$rootScope.$broadcast('messageForBox', 'ERROR', 'Filename contains bad character. Only a-z, A-Z, 0-9, . (dot), - (dash), and _ (underscore) are supported.', 'Unsupported character in file name ' + $file.name + '.');
                    this.$rootScope.dimmingPage = false;
                    this.$rootScope.$broadcast("dimming_screen_off");
                    return;
                }
                if (!($file.name.indexOf(".wav") != -1
                    || $file.name.indexOf(".nis") != -1
                    || $file.name.indexOf(".nist") != -1)) {
                    var _dialog = this.ngDialog;
                    var _scope = this.$scope;
                }
                this.$rootScope.ngProgressBar.start();
                this.$upload.upload({
                    url: BASWebServices.ConfigService.GET_URL_UPLOAD_FILE(),
                    method: BASWebServices.ConfigService.URL_MULTI_UPLOAD_HTTP_METHOD,
                    file: $file,
                    fileFormDataName: fileParameterName,
                    rootscopeInternal: this.$rootScope,
                    scopeInternal: this.$scope,
                    progressBar: this.$rootScope.ngProgressBar,
                    timeout: this.$timeout,
                    _this: this
                }).progress(function (evt) {
                    console.log('percent: ' + (100.0 * +evt.loaded / +evt.total));
                }).then(function (response) {
                    var data = response.data;
                    var status = response.status;
                    var headers = response.headers;
                    var config = response.config;
                    config.rootscopeInternal.dimmingPage = false;
                    config.rootscopeInternal.$broadcast("dimming_screen_off");
                    config.rootscopeInternal.ngProgressBar.stop();
                    config.rootscopeInternal.ngProgressBar.complete();
                    var wsrl = new BASWebServices.WebServiceResonseLink(data);
                    if (!wsrl.success) {
                        config._this.handleUnsuccessfulUpload(wsrl.output + "\n" + wsrl.warnings, "Unsuccessful", config, 'File upload unsuccessful');
                    }
                    else {
                        UploadElementController.handleSuccessfulUpload(wsrl.downloadLink, config._this.$scope, config._this.$http, config._this.$sce, config.rootscopeInternal, wsrl.warnings, config.file.name);
                        if (!isFilePartOfServiceOption) {
                            config._this.wsData.add(0, fileParameterName, wsrl.downloadLink);
                        }
                        else {
                            config._this.wsData.addOption(fileParameterName, wsrl.downloadLink);
                        }
                        if (config.scopeInternal.usingAudioPlayer == true) {
                            config.rootscopeInternal.$broadcast('usingAudioPlayer', wsrl.downloadLink);
                        }
                    }
                }).catch(function (response) {
                    var data = response.data;
                    var status = response.status;
                    var headers = response.headers;
                    var config = response.config;
                    config._this.handleUnsuccessfulUpload(data, status, config, 'File upload unsuccessfull.');
                });
            }
            this.$rootScope.dimmingPage = false;
            this.$rootScope.$broadcast("dimming_screen_off");
        };
        UploadElementController.handleSuccessfulUpload = function (fileUploaded, scope, http, sce, rootScope, warnings, filenameString) {
            var message = "File upload successful";
            scope.BPF_CONTENT = null;
            scope.TEXT_CONTENT = null;
            if (fileUploaded.toLowerCase().lastIndexOf(".wav") != -1
                || fileUploaded.lastIndexOf(".nis") != -1) {
                scope.SIGNAL = sce.trustAsResourceUrl(fileUploaded);
                message = 'Signal ' + message;
            }
            else if (fileUploaded.toLowerCase().lastIndexOf(".par") != -1) {
                scope.BPF = fileUploaded;
                http.get(scope.BPF, {
                    _scope: scope
                })
                    .then(function (response) {
                    var data = response.data;
                    var status = response.status;
                    var headers = response.headers;
                    var config = response.config;
                    var content = data;
                    config._scope.BPF_CONTENT = content;
                })
                    .catch(function (response) {
                });
                message = 'BPF ' + message;
            }
            else {
                scope.TEXT = fileUploaded;
                http.get(scope.TEXT, {
                    _scope: scope
                })
                    .then(function (response) {
                    var data = response.data;
                    var status = response.status;
                    var headers = response.headers;
                    var config = response.config;
                    var content = data;
                    var content = data;
                    config._scope.TEXT_CONTENT = content;
                })
                    .catch(function (data, status, headers, config) {
                });
                message = 'Text ' + message;
            }
            if (rootScope != null) {
                var statusLabel = 'Success';
                var warningText = "File upload of " + filenameString;
                if (warnings != "") {
                    warningText += " resulted in the following warnings: " + warnings;
                    statusLabel += ' (+Warning)';
                }
                else {
                    warningText += ' was successfull';
                }
                rootScope.$broadcast('messageBoxIgnoreOldMessages');
                rootScope.$broadcast('messageForBox', statusLabel, message, warningText);
            }
        };
        UploadElementController.prototype.handleUnsuccessfulUpload = function (data, status, config, errorMessage) {
            config.rootscopeInternal.$broadcast('messageForBox', 'ERROR', errorMessage, "Data: " + data + " | Status: " + status);
            config.rootscopeInternal.stop();
            config.rootscopeInternal.dimmingPage = false;
            config.rootscopeInternal.$broadcast("dimming_screen_off");
        };
        UploadElementController.prototype.deleteFileFromService = function (fileParameterName) {
            console.log("Deleting stuff for " + fileParameterName);
            this.$scope[fileParameterName] = null;
            this.wsData.deleteParameter(0, fileParameterName);
        };
        UploadElementController.prototype.deleteOptionFromService = function (fileParameterName) {
            this.wsData.deleteOption(fileParameterName);
        };
        UploadElementController.prototype.clickFileSelect = function (elementID) {
            var _this = this;
            setTimeout(function () {
                _this.deleteFileFromService(elementID);
                document.getElementById(elementID).click();
                console.log("Trying to get " + elementID);
            }, 0);
        };
        return UploadElementController;
    }());
    BASWebServices.UploadElementController = UploadElementController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=UploadElementController.js.map